// extracted by mini-css-extract-plugin
module.exports = {"tabs-root":"Tabs_tabs-root__AboQZ","active":"Tabs_active__J9NY3","indicator":"Tabs_indicator__2S4Z6","toLeft":"Tabs_toLeft__VqnqK"};